/** Update these values before publishing if your repository details differ. */
export const SITE_CONFIG = {
  title: 'Codytris',
  projectLabel: 'By CodyKoInABox',
  repositoryName: 'codytris',
  repositoryUrl: '',
  githubOwner: 'CodyKoInABox',
} as const;
